import { useCallback, useRef } from 'react';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

/**
 * Returns a stable `renderMarkdown(text)` that renders markdown to sanitized
 * HTML. Shared by the discovery conversation, the admin transcript viewer,
 * and the call page write-up.
 */
export function useMarkdownRenderer() {
  const mdRef = useRef<MarkdownIt | null>(null);
  if (!mdRef.current) {
    mdRef.current = new MarkdownIt({
      html: false,
      linkify: true,
      breaks: true,
      typographer: true,
    });
  }

  return useCallback((text: string) => {
    const html = mdRef.current!.render(text || '');
    return DOMPurify.sanitize(html);
  }, []);
}
